<template>
  <div
    ref="buttonSplit"
    class="split-button flex"
    :class="[hasBorderParent ? 'border-split-btn' : '']"
  >
    <button
      id="split-btn"
      class="btn flex-row primary-button"
      :class="[type, classCustom, hasBorder ? '' : 'btn-border-none']"
      :disabled="disabled"
      @click="$emit('primaryClick', $event)"
    >
      <div v-if="leftIcon" :class="['icon16 icon left', leftIcon]">
&nbsp;
      </div>
      <div v-if="text" class="text" :class="[{ 'pl-0': leftIcon }]">
        {{ text }}
      </div>
    </button>
    <div class="button-line" />
    <menu-wrapper
      class="widget-btn"
      :class="[type]"
      :disabled="disabled"
      :width-wrapper="widthWrapper"
      :is-open-prop="isOpenProp"
      :is-close-when-click-out-side="isCloseWhenClickOutSide"
      @openMenuWrapper="openMenuWrapper"
    >
      <template #menu-button="{ toggleMenu }">
        <button
          id="widget-more-btn"
          class="widget-more"
          :class="[type, classCustom, hasBorder ? '' : 'btn-border-none']"
          :disabled="disabled"
          @click.prevent="toggleMenu"
        />
      </template>
      <template #menu-content>
        <menu-item
          v-for="(item, index) in menuItems"
          :key="index"
          :icon="item.icon"
          :seperator-bottom="item.seperatorBottom"
          @menu-item-click="clickItem(item)"
        >
          {{ item.text }}
        </menu-item>
      </template>
    </menu-wrapper>
  </div>
</template>
<script>
import {
  defineComponent,
  computed,
  ref
} from 'vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';

export default defineComponent({
  name: 'MsSplitButton',
  components: {
    MenuWrapper,
    MenuItem,
  },
  props: {
    //Text hiển thị
    text: {
      default: null,
      type: String,
    },
    //Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    //Icon phải
    rightIcon: {
      default: 'chevron-down-white',
      type: String,
    },
    //Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
    type: {
      default: 'primary',
      type: String,
    },
    /**
     * Trạng thái button disabled
     */
    disabled: {
      default: false,
      type: Boolean,
    },
    /**
     * Danh sách các item của context menu
     */
    menuItems: {
      type: Array,
      default: new Array(),
    },
    /**
     * ĐVThi 18/02/2020
     * muốn đặt thêm stype cho lớp mục đích có cách để trên form tìm được đến control
     */
    classCustom: {
      default: '',
      type: String,
    },
    /**
     * NNLAM 26/02/2020
     * có cho phép tự custom vị trí dropdown menu hay không
     */
    customPositionMenu: {
      type: Boolean,
      default: false,
    },
    /**
     * NNLAM 26/02/2020
     * Set lại chiều dài menu dropdown
     */
    customWidth: {
      type: Number,
      default: 0,
    },
    /**
     * NNLAM 26/02/2020
     * khoảng cách của button so với lề trên/dưới
     */
    heightOffset: {
      type: Number,
      default: 5, //25
    },
    /**
     * NNLAM 26/02/2021
     * khoảng cách của button so với lề trái/phải
     */
    widthOffset: {
      type: Number,
      default: 25,
    },
    /**
     * NNLAM 26/02/2021
     * Có show menu khi click vào icon right của button không, mặc định có
     */
    hasShowMenu: {
      type: Boolean,
      default: true,
    },
    /**
     * NNLAM 26/02/2021
     * Có tooltip cho btt không
     */
    tooltipText: {
      type: [String, Object],
      default: null,
    },
    //border hiển thị cho các button con
    hasBorder: {
      default: false,
      type: Boolean,
    },
    //border bên ngoài 2 button con
    hasBorderParent: {
      default: false,
      type: Boolean,
    },
    /**
     * Có mở menu ra không
     */
    isOpenProp: {
      default: false,
      type: Boolean,
    },
    /**
     * Có đóng menu khi click ra ngoài không
     */
    isCloseWhenClickOutSide: {
      default: true,
      type: Boolean,
    }
  },
  emits: ['menuClick', 'primaryClick'],
  setup(props, { emit }) {
    const clickItem = (item) => {
      emit('menuClick', item);
    };
    
    const widthWrapper = ref(0);

    const  openMenuWrapper = () => {
      widthWrapper.value =
        document.getElementById('split-btn').clientWidth +
        document.getElementById('widget-more-btn').clientWidth;
    };

    return {
      clickItem,
      widthWrapper,
      openMenuWrapper,
    };
  },
});
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/components/MsButton.scss';
@import '@/assets/scss/btn.scss';
.split-icon {
  width: 36px;
  height: 24px;
  margin: 0 !important;
  .icon {
    margin: 0;
    cursor: pointer;
  }
}

.context-item {
  height: 36px;
  padding: 2px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  .context-text {
    padding: 0 8px;
  }
  &:hover {
    cursor: pointer;
    background: var(--hover-bg);
    color: #14aa8a;
  }
}
.menu-wrapper-item:hover {
  background-color: #EEF0FF !important;
}
.context-icon {
  margin-right: 8px;
}
.color-red {
  color: #ff0000;
}
.button-line {
  display: inline-block;
  width: 1px;
  height: 16px;
  background-color: #fff;
}
.split-button {
  &.border-split-btn {
    border: 1px solid #afafaf;
    border-radius: 3px;
  }
  button {
    &.primary-button {
      border-end-end-radius: unset;
      border-start-end-radius: unset;
    }
  }
}
</style>
